export type HotelGps = {
	lat: number;
	lon: number;
};

export type HotelGeographyLevel = {
	code?: number;
	level?: string;
	label?: string;
	[key: string]: unknown;
};

export type HotelGeography = {
	levels?: HotelGeographyLevel[];
	geometry?: unknown;
};

export type HotelTripAdvisor = {
	id: string;
	num_reviews: number;
	rating: number;
	ratingURL: string;
};

export type HotelPointOfInterest = {
	type: string;
	gps: HotelGps;
	label: string;
	distance: {
		value: number;
		unit: string;
	};
};

export type HotelAddress = {
	address1: string;
	city: string;
	postcode?: string;
	country: string;
};

export type HotelFormalities = {
	intro?: string;
	identity?: string;
	vaccine?: string;
	visa?: string;
};

export type HotelUsefulInformations = {
	goodtoKnow?: string[];
	transport?: string[];
	travelDocuments?: string[];
	formalities?: HotelFormalities;
	formalitiesOut?: HotelFormalities;
};

export type HotelSpecialOffer = {
	title: string;
	type: string;
	/** HTML fragments. */
	summary: string[];
	/** HTML fragments. */
	details: string[];
	pages: string[];
	ui: {
		background: string;
		textColor: string;
		titleColor: string;
	};
};

export type HotelDescriptionSectionBlock = {
	title?: string;
	/** HTML fragments. */
	paragraphs?: string[];
	photos?: { thumbnail?: string; url: string }[];
};

export type HotelDescriptionSection = {
	headline: string;
	blocks?: HotelDescriptionSectionBlock[];
	/** HTML fragments. */
	moreDetails?: string[];
	type?: number;
};

export type HotelSections = {
	primary?: HotelDescriptionSection[];
	secondary?: HotelDescriptionSection[];
};

export type HotelAccommodationDescriptionStatus =
	| "SUCCESS"
	| "LOADING"
	| "TECHNICAL_FAILURE"
	| "SESSION_EXPIRED";

export type HotelAccommodationDescriptionSuccess = {
	id: string;
	status: "SUCCESS";
	name: string;
	gps: HotelGps;
	category: number;
	location: string;
	geography: HotelGeography;
	country?: string;
	region: string;
	resort: string;
	tripadvisor: HotelTripAdvisor;
	photos?: { url: string }[];
	saleId?: number;
	topics?: string[];
	/** HTML. */
	summary: string;
	pointsOfInterest: HotelPointOfInterest[];
	included?: string[];
	notIncluded?: string[];
	address?: HotelAddress;
	usefulInformations?: HotelUsefulInformations;
	specialOffer?: HotelSpecialOffer;
	sections?: HotelSections;
	facilityGroups?: unknown[];
	sourceDescription?: string;
	destination?: {
		/** HTML fragments. */
		importantInfo?: string[];
	};
};

export type HotelAccommodationDescriptionPending = {
	id: string;
	status: Exclude<HotelAccommodationDescriptionStatus, "SUCCESS">;
};

export type HotelAccommodationDescription =
	| HotelAccommodationDescriptionSuccess
	| HotelAccommodationDescriptionPending;

export const isHotelAccommodationDescriptionSuccess = (
	hotel: HotelAccommodationDescription
): hotel is HotelAccommodationDescriptionSuccess => hotel.status === "SUCCESS";
